// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/solid/chevron-down.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'chevron-down',
  version: 'solid',
  paths: [
    {
      d: 'M6.264 9.864a.9.9 0 0 1 1.272 0L12 14.328l4.464-4.464a.9.9 0 1 1 1.272 1.272l-5.1 5.1a.9.9 0 0 1-1.272 0l-5.1-5.1a.9.9 0 0 1 0-1.272',
      fillRule: 'evenodd',
    },
  ],
}
